import { useState } from 'react';

import { PeriodeKiezer } from '@/components/PeriodeKiezer';
import { Skeleton } from '@/components/ui/skeleton';
import { periodeVoorSoort } from '../../lib/periode';
import { KpiKaarten } from './KpiKaarten';
import { OntwikkelingKaart } from './OntwikkelingKaart';
import { TopOnderwerpenKaart } from './TopOnderwerpenKaart';
import { VerdelingKaart } from './VerdelingKaart';
import { VerschuivingenKaart } from './VerschuivingenKaart';
import { useOverzicht } from './overzicht.api';

/** Het overzicht kijkt altijd naar één periode; "alles bij elkaar" hoort bij de
 *  hulpvragen, waar de vraag is wat de app inmiddels weet. */
const SOORTEN = ['maand', 'jaar'] as const;

/**
 * Het overzicht voor de Admin: vier cijfers, het opgetelde verloop per
 * hoofdonderwerp, wat erbij komt en afneemt, en welke onderwerpen het meest
 * terugkomen met hun deelonderwerpen.
 *
 * Eén periode bedient het hele scherm. Zolang die niet gekozen is bepaalt de
 * server hem (het lopende jaar) en vult het antwoord de keuzelijst, zodat de
 * client niet hoeft te weten welke maanden er in de database zitten.
 *
 * De taxonomie stond hier een moment als tweede tabje, en dat was de verkeerde
 * plek: dit scherm gaat over wat er in een periode gebeurde, en de taxonomie over
 * wat de app inmiddels weet. Die heeft nu zijn eigen scherm in de zijbalk.
 */
export function OverzichtPagina() {
  const [soort, setSoort] = useState<'maand' | 'jaar'>('jaar');
  const [periode, setPeriode] = useState<string>();

  const { data, isLoading } = useOverzicht(periode);

  const wisselSoort = (nieuw: 'maand' | 'jaar') => {
    setSoort(nieuw);
    setPeriode(periodeVoorSoort(nieuw, data?.periode.periode, data?.beschikbaar));
  };

  return (
    <div className="@container/hoofd flex flex-col gap-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        {/* Geen eigen kop: de balk bovenaan noemt het scherm al, en de
            periodekiezer ernaast zegt welke periode je bekijkt. */}
        <p className="text-sm text-muted-foreground">Waar we kennis missen</p>

        {data && (
          <PeriodeKiezer
            beschikbaar={data.beschikbaar}
            onSoort={wisselSoort}
            onWaarde={setPeriode}
            soort={soort}
            soorten={SOORTEN}
            waarde={data.periode.periode}
          />
        )}
      </div>

      {isLoading && !data ? (
        <div className="flex flex-col gap-6">
          <div className="grid grid-cols-1 gap-4 @xl/hoofd:grid-cols-2 @5xl/hoofd:grid-cols-4">
            {[0, 1, 2, 3].map((i) => (
              <Skeleton className="h-36 w-full" key={i} />
            ))}
          </div>
          <Skeleton className="h-80 w-full" />
        </div>
      ) : (
        data && (
          <>
            <KpiKaarten data={data} />
            <VerdelingKaart data={data} />
            <OntwikkelingKaart data={data} />
            <VerschuivingenKaart data={data} />
            <TopOnderwerpenKaart data={data} />
          </>
        )
      )}
    </div>
  );
}
